<template>
  <div id="top">
    <div class="ml-16 mr-16 pl-16 pr-16">
      <div class="text-align-left pt-16 pl-16 pr-16 pa-4 mb-14">
        <p>調査目的：<br>
          J-REIT（不動産投資信託）は、市場創設から24年が経過し、2025年11月現在、58銘柄が上場、市場全体の時価総額は17兆円になります。不動産賃貸事業に特化し安定した収益を裏付けに実績を重ね、不動産を運用する主体として不動産市場を牽引する存在に成長するとともに、投資家にとっては高い分配金利回りを持つ金融資産として広く認知されてきました。</p>
        <p>2025年は、REITが資本効率性を重視した運用を推進したことや、好調なオフィスや住宅の賃貸市況、ホテルの旺盛な需要を背景に、投資口市況が大きく改善し、足元の東証REIT指数は2,000ポイント水準で推移しています。一方、不動産価格が高値で推移し、適切な投資利回りで取得が難しい環境から、増資を伴う本格的な外部成長には至っていません。</p>
        <p>このような市場環境のなか、J-REITポータルサイト「JAPAN-REIT.COM」は、個人投資家の皆様がJ-REITの商品性及び昨今の投資環境の変化をどう捉えているのか、その実態把握と今後の市場動向予測、またJ-REIT市場の更なる拡大を目的とし、個人投資家を対象にアンケートを実施します。皆様のご協力をお願い致します。</p>
        <p>（アンケート所要時間5分程度）</p>
        <p>調査期間：　　　2025/11/14～2025/12/15<br>
        調査対象：　　　個人投資家<br>
        調査結果公表：　2025年12月下旬</p>

        <v-divider class="my-8"></v-divider>

        <v-row>
          <tool-button class="mx-auto" link="/survey-page" text="アンケートを開始する"></tool-button>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import ToolButton from '@/components/ToolButton.vue'

export default {
  name: 'Home',
  components: {
    ToolButton
  }
}
</script>
